import api from "./api";


export const createResource = async (formData) => {
  try {
    const response = await api.post("/resource-management/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (response.status === 200 && response.data.success) {
      return { success: true, data: response.data.data };
    } else {
      console.warn("Unexpected Response:", response);
      return { success: false, error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error creating resource:", error.message || error);
    return { success: false, error: error.message || "Failed to create resource" };
  }
};


export const fetchResources = async () => {
  try {
    const response = await api.get("/resource-management/");

    if (response.status === 200) {
      return { success: true, data: response.data.data };
    } else {
      console.warn("Unexpected Response:", response);
      return { success: false, error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error fetching resources:", error.message || error);
    return { success: false, error: error.message || "Failed to fetch resources" };
  }
};


export const updateResource = async (resourceId, title) => {
  try {
    const response = await api.put(`/resource-management/${resourceId}`, {
      title,
    });

    if (response.status === 200 && response.data.success) {
      return { success: true, data: response.data.data };
    } else {
      console.warn("Unexpected Response:", response);
      return { success: false, error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error updating resource:", error.message || error);
    return { success: false, error: error.message || "Failed to update resource" };
  }
};


export const deleteResource = async (resourceId) => {
  try {
    const response = await api.delete(`/resource-management/${resourceId}`);

    if (response.status === 200 && response.data.success) {
      return { success: true, data: response.data.data };
    } else {
      console.warn("Unexpected Response:", response);
      return { success: false, error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error deleting resource:", error.message || error);
    return { success: false, error: error.message || "Failed to delete resource" };
  }
};